module.exports = __webpack_public_path__ + "static/img/Natural language.cea4b3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/technology/Natural language.jpg
// module id = Iu7A
// module chunks = 1